import { useT } from '../../hooks/useT';
import { getIcon } from '../../utils/iconRegistry';
import styles from './FeatureCards.module.css';

function FeatureCards({ titleKey, descKey, features = [] }) {
  const t = useT();

  return (
    <div className={styles.section}>
      {titleKey && <h2 className={styles.sectionTitle}>{t(titleKey)}</h2>}
      {descKey && <p className={styles.sectionDesc}>{t(descKey)}</p>}
      <div className={styles.featureGrid}>
        {features.map((feat) => {
          const Icon = getIcon(feat.icon);
          return (
            <div key={feat.titleKey} className={styles.featureCard}>
              {Icon && <Icon className={styles.featureIcon} />}
              <h3 className={styles.featureTitle}>{t(feat.titleKey)}</h3>
              <p className={styles.featureDesc}>{t(feat.descKey)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FeatureCards;
